import React from 'react'
import HomeLeft from '../home/home_left/HomeLeft'
import { VIDEOS_SEARCH } from '../../graphql-client/Queries'
import { useQuery } from '@apollo/client'
import { useParams } from 'react-router-dom'
import VideoCard from '../home/home_right/videoCard/VideoCard'
import NotificationError from '.././NotificationError'
import CardSubUser from '../userSub/CardSubUser'
export default function VideosSearch(props) {
    const filter = useParams()
    const {data, loading, error} = useQuery(VIDEOS_SEARCH,{
        variables:filter
    })
    if(loading) return 'loading ...'
    if(error) return 'error ...'
    
    return (
        <div className="row">
            <HomeLeft></HomeLeft>
            <div className="col-xxl-10 col-xl-10 col-lg-10 col-mb-10 col-sm-12">
                <div className="p-0 marginVideoRecommend">
                    {
                    data.videosSearch.usersSearch.length > 0
                    &&
                    <div className="row ms-auto mt-1">
                        <h5 className='mt-3 mb-1'>Tác giả: </h5 >
                            {data.videosSearch.usersSearch.map((user)=>{
                                return (
                                    <CardSubUser
                                        key={user.id}
                                        idUser={user.id}
                                        avatarUser={user.avatar}
                                        username={user.username}
                                        about={user.about}
                                        intUserSub={user.countSubscribedTo}
                                    ></CardSubUser>
                                    )
                                })
                            }
                    </div>}
                    <h5 className='mt-3 mb-3 ps-3'>Học liệu: </h5 >
                        {
                        data.videosSearch.videosSearch.length ===0
                        ?<NotificationError text={'Không tìm thấy Tài liệu mà bạn yêu cầu.'}></NotificationError>
                        :
                        <div className="row ms-auto mt-3">
                        { data.videosSearch.videosSearch.map((video)=>{
                                return (
                                    <VideoCard
                                    key={video.id}
                                    title ={video.title}
                                    username={video.user.username}
                                    date={video.createdAt}
                                    view={video.countView}
                                    like={video.countLike}  
                                    videoId={video.id}
                                    avatarUser={video.user.avatar}
                                    document={video.document}
                                    idUser={video.user.id}
                                    thumbnail={video.thumbnail}
                                    >
                                    </VideoCard>
                                    )
                                })
                            }
                        </div>
                        }
                </div> 
            </div>
        </div>
    )
}
